import Testimonials from "@/components/waylio/Testimonials";

export default function ClientStoriesPage() {
  return (
    <main className="pt-10 md:pt-12">
      <Testimonials />
    </main>
  );
}
